<template>
  <div class="vue-tempalte bg-light">
    <!-- Navigation -->
    <div class="container">
      <div class="sponsors-logos row">
        <div class="col-sm-6 text-lg-right text-sm-center">
          <img class="widthx2 mt-sm-3" :src="sponsorsLogos.eurocidade">
          <img class="" :src="sponsorsLogos.aetc">
        </div>
        <div class="col-sm-6 text-lg-left text-sm-center">
          <img class="" :src="sponsorsLogos.chavesverin">
          <img class="" :src="sponsorsLogos.terhtt">
          <img class="" :src="sponsorsLogos.interaireculturel">
        </div>
      </div>
    </div>
    <!-- Main -->
    <div class="App">
      <router-view />
    </div>
  </div>
</template>

<script>

export default({
  data() {
    return {
      sponsorsLogos: {
        interreg: require('@/assets/images/interreg.png'),
        eurocidade: require('@/assets/images/Eurocidade2020.png'),
        aetc: require('@/assets/images/aetc.png'),
        chavesverin: require('@/assets/images/chavesverin.png'),
        terhtt: require('@/assets/images/terhtt.png'),
        interaireculturel: require('@/assets/images/interaireculturel.png')
      },
      bannerImg: require('@/assets/images/banner.jpg'),
      bannerImgR: require('@/assets/images/banner_responsive.jpg')
    }
  },
})
</script>
